// components/ScrollAnimations.js
import { motion } from 'framer-motion';
import styled from 'styled-components';

// Parallax Container
export const ParallaxContainer = styled(motion.div)`
  position: relative;
  overflow: hidden;
`;

// Parallax Background
export const ParallaxBackground = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background: ${props => props.background || 'transparent'};
  z-index: -1;
`;

// Fade In Up Animation
export const FadeInUp = styled(motion.div).attrs(() => ({
  initial: { opacity: 0, y: 60 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.6, ease: "easeOut" }
}))``;

// Slide In From Left
export const SlideInLeft = styled(motion.div).attrs(() => ({
  initial: { opacity: 0, x: -60 },
  whileInView: { opacity: 1, x: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.6, ease: "easeOut" }
}))``;

// Slide In From Right
export const SlideInRight = styled(motion.div).attrs(() => ({
  initial: { opacity: 0, x: 60 },
  whileInView: { opacity: 1, x: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.6, ease: "easeOut" }
}))``;

// Scale Up Animation
export const ScaleUp = styled(motion.div).attrs(() => ({
  initial: { opacity: 0, scale: 0.8 },
  whileInView: { opacity: 1, scale: 1 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.5, ease: "easeOut" }
}))``;

// Stagger Children Animation Container
export const StaggerContainer = styled(motion.div).attrs(() => ({
  initial: "hidden",
  whileInView: "visible",
  viewport: { once: true, margin: "-50px" },
  variants: {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2
      }
    }
  }
}))``;

// Stagger Child Item
export const StaggerItem = styled(motion.div).attrs(() => ({
  variants: {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  },
  transition: { duration: 0.5 }
}))``;

// Typewriter Effect Component
export const TypewriterText = styled(motion.span)`
  display: inline-block;
  overflow: hidden;
  border-right: 2px solid ${props => props.theme.colors.primary};
  white-space: nowrap;
  margin: 0 auto;
  animation: typing 3.5s steps(40, end), blink-caret 0.75s step-end infinite;
  
  @keyframes typing {
    from { width: 0 }
    to { width: 100% }
  }
  
  @keyframes blink-caret {
    from, to { border-color: transparent }
    50% { border-color: ${props => props.theme.colors.primary} }
  }
`;